import BillingsOrderForwardRelatedTaxiTaxi, {
  BillingsOrderForwardRelatedTaxiTaxiItem,
  BillingsOrderForwardRelatedTaxiTaxiItemContractDetails,
} from "./billings-order-forward-related-taxi-taxi";
import BillingsOrderForwardRelatedTaxiTaxiResponse, {
  BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel,
  BillingsOrderForwardRelatedTaxiTaxiResponseItem,
  BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus,
  BillingsOrderForwardRelatedTaxiTaxiResponseOrderForwardingAction,
} from "../../../../../api/raily/billings/order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";

const createDataItemBillingModel = (
  billingModel: BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItemStatus = (
  status: BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus,
): BillingStatus => {
  switch (status) {
    case BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
    case BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
  }
};

const createDataItemContractDetails = (
  orderForwardingAction: BillingsOrderForwardRelatedTaxiTaxiResponseOrderForwardingAction,
): BillingsOrderForwardRelatedTaxiTaxiItemContractDetails => {
  return {
    companyName: orderForwardingAction.contract.consumerTaxi.displayName,
    distanceRate: orderForwardingAction.contract.distanceRate,
    model: createDataItemBillingModel(orderForwardingAction.contract.model),
  };
};

const createDataItem = (
  data: BillingsOrderForwardRelatedTaxiTaxiResponseItem,
): BillingsOrderForwardRelatedTaxiTaxiItem => {
  return {
    billingUuid: data.id,
    forwardingUuid: data.orderForwardingAction.id,
    contractDetails: createDataItemContractDetails(data.orderForwardingAction),
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    amountForDistance: data.amountForDistance,
    internalOrderId:
      data.orderForwardingAction.transportingOrder.cargoOrder.humanId,
    allContributionsAmount: data.allContributionsAmount,
    isDraft: data.draft,
    date: data.date,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
    status: createDataItemStatus(data.status),
    readOnly: data.readOnly,
  };
};

const createData = (
  responseData: BillingsOrderForwardRelatedTaxiTaxiResponseItem[],
): BillingsOrderForwardRelatedTaxiTaxiItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsOrderForwardRelatedTaxiTaxiResponse,
): BillingsOrderForwardRelatedTaxiTaxi => {
  return {
    data: createData(response.data),
  };
};

const billingsOrderForwardRelatedTaxiTaxiFactory = {
  create,
};

export default billingsOrderForwardRelatedTaxiTaxiFactory;
